import { render, staticRenderFns } from "./bk.vue?vue&type=template&id=74f24fc6&scoped=true&"
import script from "./bk.vue?vue&type=script&lang=js&"
export * from "./bk.vue?vue&type=script&lang=js&"
import style0 from "./bk.vue?vue&type=style&index=0&id=74f24fc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f24fc6",
  null
  
)

export default component.exports